import { makeAutoObservable, observable, action, computed } from "mobx";
import { useLocalObservable } from "mobx-react-lite";
import { createContext, useContext } from "react";
import { PlaygroundDialogType } from "./constants";

class PlaygroundDialogStore {
  @observable _isDialogOpen = false;
  @observable _dialogType: PlaygroundDialogType | null = null;
  @observable _onClose?: () => void;

  constructor() {
    makeAutoObservable(this);
  }

  @action setIsDialogOpen({
    isOpen,
    dialogType,
    onClose,
  }: {
    isOpen: boolean;
    dialogType: PlaygroundDialogType;
    onClose?: () => void;
  }) {
    this._isDialogOpen = isOpen;
    this._dialogType = dialogType;
    this._onClose = onClose;
  }

  @computed get isDialogOpen() {
    return this._isDialogOpen;
  }

  @computed get dialogType() {
    return this._dialogType;
  }

  @action onClose() {
    this._onClose?.();
  }
}

export const PlaygroundDialogStoreContext =
  createContext<PlaygroundDialogStore | null>(null);

export const PlaygroundDialogStoreProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const store = useLocalObservable(() => new PlaygroundDialogStore());

  return (
    <PlaygroundDialogStoreContext.Provider value={store}>
      {children}
    </PlaygroundDialogStoreContext.Provider>
  );
};

export const usePlaygroundDialogStore = () => {
  const store = useContext(PlaygroundDialogStoreContext);
  if (!store) {
    throw new Error(
      "usePlaygroundDialogStore must be used within a PlaygroundDialogStoreProvider",
    );
  }
  return store;
};
